import LoadingComponent from "./LoadingComponent.jsx";
import Tooltip from "./Tooltip.jsx";
import React from "react";

export default function LoadingCard({loading, className, title, tooltip, children}) {
    return <LoadingComponent
        key={'pno-total'}
        loading={loading}
        className={
            "comp__roundedBox flex flex-col justify-between col-span-12 "
            + " bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700"
            + " " + (className ?? '')
        }
    >
        {title && <header
            className={'flex gap-2 px-4 sm:px-5 py-3 sm:py-4 border-b border-slate-100 dark:border-slate-700 items-center'}>
             <h3
                className="text-xs md:text-sm font-semibold text-slate-800 dark:text-slate-100 uppercase"
            >
                {title}
            </h3>
            {tooltip &&
                <Tooltip bg="dark" size="md" position="right" className={'inline-flex'}>
                    <div className="text-xs text-gray-200">
                        {tooltip}
                    </div>
                </Tooltip>
            }
        </header>}
        <div className={'px-4 py-2 h-full'}>
            {children}
        </div>
    </LoadingComponent>;
}